// src/App.jsx
import React, { useState } from 'react';
import AgendaScreen from './components/screens/AgendaScreen';
import ShopScreen from './components/screens/ShopScreen';
import NotificationScreen from './components/screens/NotificationsScreen.jsx';
import Header from './components/layout/Header'
import SideMenu from './components/layout/SideMenu';
import BottomNav from './components/layout/BottomNav';
import HomeScreen from './components/screens/HomeScreen.jsx';
import NoFoundScreen from './components/screens/NoFoundScreen.jsx';
import ChatScreeen from './components/screens/ChatScreen';
import GreenClubScreen from './components/screens/GreenClubScreen.jsx';
import ProductScreen from './components/screens/ProdutosScreen.jsx';
import AutomationScreen from './components/screens/AutomationScreen.jsx';
import ProfessionalScreen from './components/screens/ProfessionalScreen.jsx';
import LoginScreen from './components/screens/LoginScreen.jsx';
import GramopollLogoImage from './components/assets/logo-text.png'
import { ToastContainer } from 'react-toastify';
import HistoricoServicos from './components/screens/HistoricoScreen.jsx';

const GramopoolApp = () => {
    const [activeScreen, setActiveScreen] = useState(
      sessionStorage.getItem('userName') === null ? 'login' : 'home'
    );
    const [menuOpen, setMenuOpen] = useState(false);
    
    // Renderiza a tela atual
    const renderScreen = () => {
      switch (activeScreen) {
        case 'login':
          return <LoginScreen setActiveScreen={setActiveScreen} />;
        case 'home':
          return HomeScreen({setActiveScreen});
        case 'agenda':
          return <AgendaScreen setActiveScreen={setActiveScreen} />;
        case 'shop':
          return <ShopScreen setActiveScreen={setActiveScreen} />;
        case 'notifications':
          return <NotificationScreen setActiveScreen={setActiveScreen} />;
        case 'green-club':
          return <GreenClubScreen setActiveScreen={setActiveScreen} />;
        case 'chat':
          return <ChatScreeen setActiveScreen={setActiveScreen} />;
        case 'product':
          return <ProductScreen setActiveScreen={setActiveScreen}/>
        case 'automation':
          return <AutomationScreen />
        case 'pro':
          return <ProfessionalScreen setActiveScreen={setActiveScreen}/>;
          case 'history':
          return <HistoricoServicos setActiveScreen={setActiveScreen}/>;
        default:
          return <NoFoundScreen 
            title={activeScreen.charAt(0).toUpperCase() + activeScreen.slice(1)}
            setActiveScreen={setActiveScreen}
          />
      }
    };
  
    if (activeScreen === 'login') return (
      <div className="overflow-hidden h-screen flex flex-col gap-8 bg-gradient-to-b from-[#057695] to-[#045369]">
        <ToastContainer 
          position="top-right" // Pode ser top-left, bottom-right etc.
          autoClose={3000}     // Tempo em milissegundos
          hideProgressBar={false}
          newestOnTop={false}
          closeOnClick
          rtl={false}
          pauseOnFocusLoss
          draggable
          pauseOnHover
        />
        <img 
          src={GramopollLogoImage} 
          alt="GramopoolLogoImage"
          className='h-1/4 mx-auto mt-10'
        />
        <div className="flex-1 overflow-hidden">
          {renderScreen()}
        </div>
      </div>
    );

    return (
      <div className="h-screen flex flex-col bg-gray-50">
        <ToastContainer 
          position="top-right" // Pode ser top-left, bottom-right etc.
          autoClose={3000}     // Tempo em milissegundos
          hideProgressBar={false}
          newestOnTop={false}
          closeOnClick
          rtl={false}
          pauseOnFocusLoss
          draggable
          pauseOnHover
        />
        <Header
          title={"Gramopool"}
          menuOpen={menuOpen}
          setMenuOpen={setMenuOpen}
        />
        <SideMenu
          menuOpen={menuOpen}
          setMenuOpen={setMenuOpen}
          setActiveScreen={setActiveScreen}
        />
        <div className="flex-1 overflow-y-auto">
          {renderScreen()}
        </div>
        <BottomNav 
          activeScreen={activeScreen}
          setActiveScreen={setActiveScreen}
        />
      </div>
    );
  };

export default GramopoolApp;